import React, { useMemo } from "react";
import {
  FaCheckCircle,
  FaClock,
  FaEuroSign,
  FaFileInvoiceDollar,
  FaWallet,
} from "react-icons/fa";
import StatCard from "../ui/StatCard";
import { money } from "../utils/expenseAdminFormat";

export default function ExpenseStatsCards({ claims = [] }) {
  const stats = useMemo(() => {
    const total = claims.length;
    const submitted = claims.filter((c) => c.statut === "submitted").length;
    const approved = claims.filter((c) => c.statut === "approved").length;
    const paid = claims.filter((c) => c.statut === "paid").length;

    const totalAmount = claims.reduce(
      (acc, c) => acc + Number(c.total_general || 0),
      0,
    );

    const toPayAmount = claims
      .filter((c) => ["submitted", "approved"].includes(c.statut))
      .reduce((acc, c) => acc + Number(c.total_general || 0), 0);

    return {
      total,
      submitted,
      approved,
      paid,
      totalAmount,
      toPayAmount,
    };
  }, [claims]);

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-5">
      <StatCard
        icon={<FaFileInvoiceDollar className="text-lg" />}
        label="Fiches visibles"
        value={stats.total}
        subvalue="Selon les filtres actifs"
        tone="slate"
      />

      <StatCard
        icon={<FaClock className="text-lg" />}
        label="Soumises"
        value={stats.submitted}
        subvalue="En attente de validation"
        tone="amber"
      />

      <StatCard
        icon={<FaCheckCircle className="text-lg" />}
        label="Approuvées"
        value={stats.approved}
        subvalue="Prêtes pour règlement"
        tone="emerald"
      />

      <StatCard
        icon={<FaWallet className="text-lg" />}
        label="Payées"
        value={stats.paid}
        subvalue="Workflow terminé"
        tone="sky"
      />

      <StatCard
        icon={<FaEuroSign className="text-lg" />}
        label="Montant visible"
        value={money(stats.totalAmount)}
        subvalue={`À payer : ${money(stats.toPayAmount)}`}
        tone="rose"
      />
    </div>
  );
}